import { render, staticRenderFns } from "./AccountBoxOutline.vue?vue&type=template&id=015ab5d3"
import script from "./AccountBoxOutline.vue?vue&type=script&lang=js"
export * from "./AccountBoxOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports